import API from './config'

export const AccreditationProcessAPI = {

    async getAllByClientId(clientId) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get(`/accreditationProcesses/getAllByClientId?clientId=${clientId}`, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }
    },

    async save(accreditationProcess) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = accreditationProcess.id ?
                await API.put(`/accreditationProcesses/update`, accreditationProcess, config)
                :
                await API.post(`/accreditationProcesses/create`, accreditationProcess, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }
    },

    async delete(accreditationProcessId) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response =
                await API.delete(`/accreditationProcesses/delete/${accreditationProcessId}`, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }
    },

}